import { Waves, Anchor, Tag, Rocket, Sun, Wand2, Trash2, Video, Grid3x3, Zap, FileText, Mail } from "lucide-react";

// Goal presets — kept in sync with backend campaign_service.GOAL_PRESETS.
export const GOALS = [
  { key: "reef_awareness", name: "Reef Awareness Week", pitch: "Educate followers on reef conservation with heart, not alarmism.", icon: Waves, color: "#4FD1C5" },
  { key: "underwater_cleanup", name: "Underwater Cleanup Launch", pitch: "Rally divers and locals around a cleanup event — awareness, recruitment, day-of coverage, impact reveal.", icon: Trash2, color: "#0EA5E9" },
  { key: "open_water", name: "Open Water Launch", pitch: "Turn curious followers into signed-up students.", icon: Anchor, color: "#1D4E89" },
  { key: "black_friday", name: "Black Friday", pitch: "Build tension across the campaign, reveal the offer late.", icon: Tag, color: "#0A2342" },
  { key: "product_launch", name: "Product Launch", pitch: "Tease → educate → demonstrate → offer. Classic launch arc.", icon: Rocket, color: "#F59E0B" },
  { key: "seasonal_promo", name: "Seasonal Promo", pitch: "Anchor content to the season for maximum relevance.", icon: Sun, color: "#38BDF8" },
  { key: "custom", name: "Custom", pitch: "Describe your goal and we design the arc from scratch.", icon: Wand2, color: "#8B5CF6", dashed: true },
];

export const PIECE_TYPE_ICON = {
  reel: Video,
  carousel: Grid3x3,
  hooks: Zap,
  hook_bank: Zap,
  blog: FileText,
  seo_blog: FileText,
  email: Mail,
  email_campaign: Mail,
};

export const PIECE_TYPE_LABEL = {
  reel: "Reel",
  carousel: "Carousel",
  hooks: "Hook bank",
  hook_bank: "Hook bank",
  blog: "Blog",
  seo_blog: "Blog",
  email: "Email",
  email_campaign: "Email",
};

export function goalFor(key) {
  return GOALS.find((g) => g.key === key) || GOALS.find((g) => g.key === "custom");
}
